import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {

  private titleSource = new BehaviorSubject<string>('Please Wait');
  private messageSource = new BehaviorSubject<string>(
    'This may take a few moments.'
  );

  title$ = this.titleSource.asObservable();
  message$ = this.messageSource.asObservable();

  setMessage(title: string, message: string): void {
    this.titleSource.next(title);
    this.messageSource.next(message);
  }

  reset(): void {
    this.titleSource.next('Please Wait');
    this.messageSource.next(
      'This may take a few moments.'
    );
  }
}